// extracted by mini-css-extract-plugin
export default {"col":"eT3ekWA71xA1c7BnD_E6"};